import React from "react";
import { ShieldCheck, ShieldAlert, Loader2 } from "lucide-react";

export default function StatusBadge({ status, loading, className = "", testid }) {
  if (loading) {
    return (
      <span
        data-testid={testid}
        className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-sm border border-border bg-muted text-muted-foreground font-mono text-xs uppercase tracking-widest ${className}`}
      >
        <Loader2 className="w-3.5 h-3.5 animate-spin" strokeWidth={1.5} />
        <span>Checking…</span>
      </span>
    );
  }
  const isTampered = status === "TAMPERED";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-sm border font-mono text-xs uppercase tracking-widest transition-colors ${
        isTampered
          ? "border-status-tampered/40 bg-status-tampered/10 text-status-tampered tampered-pulse"
          : "border-status-ok/40 bg-status-ok/10 text-status-ok"
      } ${className}`}
    >
      {isTampered ? <ShieldAlert className="w-3.5 h-3.5" strokeWidth={1.5} /> : <ShieldCheck className="w-3.5 h-3.5" strokeWidth={1.5} />}
      <span className="relative inline-flex">
        <span className={`absolute -left-3 top-1.5 w-1.5 h-1.5 rounded-full animate-pulse ${isTampered ? "bg-status-tampered" : "bg-status-ok"}`}></span>
        {status || "—"}
      </span>
    </span>
  );
}
